"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.serializeHxGlobalDefaultPreferences = void 0;
var HxSyncPreferences_1 = require("./HxSyncPreferences");
var HxSetPushNotificationSettingsArgs_1 = require("./HxSetPushNotificationSettingsArgs");
var HxAddInSettings_1 = require("./HxAddInSettings");
function serializeHxGlobalDefaultPreferences(_arg) {
    var output = [];
    output.push(HxSyncPreferences_1.serializeHxSyncPreferences(_arg.syncPreferences));
    var syncingViewsOutput = [];
    _arg.syncingViews.forEach(function (item) { return syncingViewsOutput.push(item); });
    output.push(syncingViewsOutput);
    output.push(_arg.autoResetAADClaimsAfterUse);
    output.push(_arg.pushNotificationSettings !== undefined);
    if (_arg.pushNotificationSettings !== undefined) {
        output.push(HxSetPushNotificationSettingsArgs_1.serializeHxSetPushNotificationSettingsArgs(_arg.pushNotificationSettings));
    }
    output.push(_arg.shouldDeferFilterUpdates);
    output.push(_arg.smimeEnabled);
    output.push(_arg.addInSettings !== undefined);
    if (_arg.addInSettings !== undefined) {
        output.push(HxAddInSettings_1.serializeHxAddInSettings(_arg.addInSettings));
    }
    output.push(_arg.seamlessSendEnabled);
    output.push(_arg.improveMailSearchPerformance);
    output.push(_arg.processMailSearchResultsInPayloadOnly);
    output.push(_arg.rollupLatestSearchHitInConversation);
    output.push(_arg.rollupLatestServerIdsInConversation);
    output.push(_arg.hxSettingsEnabled);
    output.push(_arg.inboxUnreadCountIncludesOtherView);
    output.push(_arg.storageDispatchThresholdTimeNs);
    output.push(_arg.validateMandatoryMipLabels);
    output.push(_arg.implicitOriginDownloadForReplyEnabled);
    return output;
}
exports.serializeHxGlobalDefaultPreferences = serializeHxGlobalDefaultPreferences;
